export default __webpack_public_path__ + "static/media/dfiv_logo_rgb_small.4a842206.png";